import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Subscription as RxSubscription } from 'rxjs';

import { PageEvent } from '@angular/material/paginator';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { CohortsApiService } from './cohorts-api-service';

export class CohortsDataSource extends ApiDataSource {
  [x: string]: any;
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public Cohorts: BehaviorSubject<any> = new BehaviorSubject([]);
  public ListingCohorts: BehaviorSubject<any> = new BehaviorSubject([]);
  public Subscriptions: RxSubscription[] = [];
  protected Data: BehaviorSubject<[]> = new BehaviorSubject([]);
  constructor(
    public CohortsApi: CohortsApiService,
    private readonly role: string,
    public type: string,
    protected id?: number
  ) {
    super();
  }

  protected loadData(_pageEvent: PageEvent): Promise<void> {
    this.load();
    return Promise.resolve();
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }

  public load(CohortsDataSource?: CohortsDataSource) {
    this.id = CohortsDataSource?.id || this.id;
    this.type = CohortsDataSource?.type || this.type;
    if (!this.id) return;

    this.loading.next(true);

    this.CohortsApi.getAllCohorts(this.role, this.id, this.type).then(
      (data) => {
        this.Cohorts.next(data);
        this.loading.next(false);
      },
      (error) => this.loading.next(false)
    );
  }

  public save(Cohorts: any) {
    return this.CohortsApi.save(this.role, this.id, this.type, Cohorts).then((result) => {
      this.load();
      return result;
    });
  }
  public disconnect(collectionViewer?: CollectionViewer) {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
